// Import Actions
import { SET_PRODUCTS, SET_PRODUCT_PICTURES } from './ProductActions';

// Initial State
export const initialState = {
    data: [],
};

const ProductReducer = (state = initialState, action) => {
    switch(action.type) {
        case SET_PRODUCTS:
            return {
                ...state,
                data: state.data.filter(product => !action.products.find(newProduct => newProduct._id === product._id)).concat(action.products),
            };

        case SET_PRODUCT_PICTURES:
            return {
                ...state,
                data: state.data.map(product => {
                    if(product._id === action.productId) {
                        return {
                            ...product,
                            picturesUrl: action.picturesUrl,
                        };
                    }
                    return product;
                }),
            };

        default:
            return state;
    }
};

export default ProductReducer;
